<template>
    <div @click="$emit('click')"
         v-tooltip="getAdditionalInfoTooltip()"
         @mouseover="hovered = true"
         @mouseleave="hovered = false"
         class="row item-row"
         :class="{ 'shadow-sm selected-row': hovered || isSelected }">
        <div v-tooltip="statusInfo.text" class="col-1 px-2">
            <AppColoredSquire :color="statusInfo.color"/>
        </div>
        <div class="col-4 overflow-ellipsis px-1">
            <span>{{ item.number }}</span>
            <span v-if="item.po" class="text-muted font-12 ml-2">({{ item.po }})</span>
        </div>
        <div class="col-5 overflow-ellipsis px-1">
            {{ item.supplier }}
        </div>
        <div class="col-2 overflow-ellipsis text-right px-1">
            {{ formattedTotal }}
            <span v-show="hasSelectedLines" class="with-selected-lines">
                <i class="fa fa-check fa-lg"></i>
            </span>
        </div>
    </div>
</template>

<script>
import AppColoredSquire from '../../../../../components/shared/AppColoredSquire'
import {getDefaultFormattedMoney} from '@/utils/currency'
import {$lang} from '@/views/settings/team/lang'
import {forceToNumber} from '@/utils'

export default {
    name: 'MatchingItem',
    components: {AppColoredSquire},
    props: {
        item: {
            type: Object,
            required: true
        },
        isSelected: {
            type: Boolean,
            required: true
        },
        hasSelectedLines: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hovered: false
        }
    },
    computed: {
        statusInfo() {
            if (!this.item) {
                return {color: '', text: ''}
            }
            if (!this.item.isOpen) {
                return {color: 'GREY', text: 'This invoice is currently closed'}
            } else if (!this.item.isFulfilled) {
                return {color: 'GREEN', text: 'This invoice is open and has not been fulfilled'}
            } else if (this.item.isOpen && this.item.isFulfilled) {
                return {color: 'RED', text: 'This invoice has been fulfilled'}
            }
            return {color: 'GREEN', text: '...'}
        },

        formattedTotal() {
            return this.formatCurrency(this.item.total)
        },

        formattedAllocated() {
            return this.formatCurrency(this.item.allocated)
        },

        formattedRemaining() {
            return this.formatCurrency(this.remainingAmount)
        },

        remainingAmount() {
            return forceToNumber(this.item.total) - forceToNumber(this.item.allocated)
        }
    },
    methods: {
        formatCurrency(value) {
            return getDefaultFormattedMoney(value, _.get(this.item, 'currency.symbol', ''))
        },

        getAdditionalInfoTooltip() {
            let content = ''
            if (this.item.number) {
                content += `<div>Number: ${this.item.number}</div>`
            }
            if (this.item.reference) {
                content += `<div>Reference: ${this.item.reference}</div>`
            }
            if (this.item.po && String(this.item.po) !== String(this.item.number)) {
                content += `<div>PO: ${this.item.po}</div>`
            }
            if (this.item.note && String(this.item.note) !== String(this.item.number)) {
                content += `<div>Note: ${this.item.note}</div>`
            }
            if (this.item.dateIssued) {
                content += `<div>Date Issued: ${this.item.dateIssued}</div>`
            }
            if (this.item.supplier) {
                content += `<div>${$lang.supplier.singular}: ${this.item.supplier}</div>`
            }
            if (this.item.allocated) {
                content += `<div>Allocated: <span class="text-warning">${this.formattedAllocated}</span></div>`
                content += `<div>Remainign: <span class="text-green">${this.formattedRemaining}</span></div>`
            }
            return {
                content,
                classes: 'tooltip-white text-left',
                delay: 500
            }
        }
    }
}
</script>

<style scoped lang="scss">
button {
    width: 160px;
}

.item-row {
    align-items: center;
    border: 1px solid $color-grey-light;
    border-radius: 3px;
    margin: 0 0 3px;
    padding: 8px;
    text-align: left;

    &:hover {
        cursor: pointer;
    }
}

.selected-row {
    border: 1px solid $color-purple-light;
    background: $color-purple-soft;
}

.with-selected-lines {
    font-size: 12px;
    padding-left: 4px;
    color: $color-purple-primary;
}
</style>
